<!-- NOT: Ölçüm Modu Kumpas -->
<div style="display: flex;flex-direction:column;">

    <!-- NOT: Seçim Türü 1-->
    <div style="display: flex; flex-direction: row;">
        <span>Seçim 1:</span>
        <select name="cars" id="cars" style="outline:none;flex:1;" [(ngModel)]="secim1Turu">
            <option value="Her Şey">Her Şey</option>
            <option value="Her Şey;(Düzlemli)">Her Şey;(Düzlemli)</option>
            <option value="Sadece Nokta">Sadece Nokta</option>
            <option value="Sadece Çizgi">Sadece Çizgi</option>
            <option value="Sadece Yüzey">Sadece Yüzey</option>
            <option value="Sadece Gruplar">Sadece Grup</option>
            <option value="Nokta Koy">Nokta Koy</option>
        </select>
    </div>

    <!-- NOT: Seçim Türü 2-->
    <div style="display: flex; flex-direction: row;">
        <span>Seçim 2:</span>
        <select name="cars" id="cars" style="outline:none;flex:1;" [(ngModel)]="secim2Turu">
            <option value="Her Şey">Her Şey</option>
            <option value="Her Şey;(Düzlemli)">Her Şey;(Düzlemli)</option>
            <option value="Sadece Nokta">Sadece Nokta</option>
            <option value="Sadece Çizgi">Sadece Çizgi</option>
            <option value="Sadece Yüzey">Sadece Yüzey</option>
            <option value="Sadece Gruplar">Sadece Grup</option>
            <option value="Nokta Koy">Nokta Koy</option>
        </select>
    </div>

    <!-- NOT:  Seçimler -->

    <div class="ui horizontal divider header"
        style="margin-top: 0.1rem;margin-bottom:0.1rem;color: white;text-transform: unset;font-size:0.8rem;">
        Seçimler:
    </div>

    <!-- GPU Mode Badge -->
    <div style="padding: 0.3rem; text-align: center; font-size: 0.7rem; margin-bottom: 0.3rem;">
        <span [ngStyle]="{
            'background': gpuMode === 'WEBGPU' ? '#00ff00' : gpuMode === 'WASM' ? '#ffaa00' : '#ff4444',
            'color': '#000',
            'padding': '0.2rem 0.5rem',
            'border-radius': '3px',
            'font-weight': 'bold'
        }">
            {{ gpuMode === 'WEBGPU' ? '🚀 GPU' : gpuMode === 'WASM' ? '⚡ WASM' : '🐢 CPU' }}
        </span>
    </div>

    <!-- BİLGİ:  Seçim 1 Tipi -->
    <div style="display: flex; flex-direction: row; align-items: center;">
        <div class="ui label" style="flex: 1;padding: 0.3rem;">
            Seçim 1 Tipi:
            <a class="detail" style="color: black;margin-left: 0.1rem;"> {{ sonuc1Tipi ? sonuc1Tipi : "Seçilen Yok"
                }} </a>
        </div>
        <!-- 🎯 ÖLÇÜM MODU TOGGLE: 5 mod: Kısa Düz, En Kısa, Merkez, En Uzak, Uzak Düz -->
        <!-- NOT: Tüm yüzeylerde (düzlem dahil) aktif - paralel olmayan yüzeylerde de ölçüm modu seçilebilir -->
        <!-- 🎯 SOL TIK: Sonraki mod, SAĞ TIK: Önceki mod -->
        <button *ngIf="secim1MerkezBilgisi || sonuc1Tipi === 'Yüzey'"
                (click)="toggleSecim1OlcumModu()"
                (contextmenu)="toggleSecim1OlcumModuGeri($event)"
                title="Sol tık: Sonraki mod | Sağ tık: Önceki mod"
                style="margin-left: 4px; padding: 2px 6px; font-size: 0.7rem; border: 1px solid #666; border-radius: 3px; cursor: pointer;"
                [ngStyle]="{'background': secim1OlcumModu === 'enKisaDuz' ? '#2196F3' : secim1OlcumModu === 'enKisa' ? '#607D8B' : secim1OlcumModu === 'merkez' ? '#4CAF50' : secim1OlcumModu === 'enUzak' ? '#FF5722' : secim1OlcumModu === 'enUzakDuz' ? '#9C27B0' : '#888', 'color': 'white'}">
            {{ getOlcumModuLabel(secim1OlcumModu) }}
        </button>
    </div>

    <!-- BİLGİ:  Seçim 1 Yüzey Tipi -->
    <div style="display: flex; flex-direction: row;margin-top:3px;" *ngIf="yuzey1TipiInfo && sonuc1Tipi === 'Yüzey'">
        <div class="ui label" style="flex: 1;padding: 0.3rem;background-color: #e3f2fd;">
            Yüzey Tipi:
            <a class="detail" style="color: black;margin-left: 0.1rem;">
                {{ yuzey1TipiInfo?.tip ? (yuzey1TipiInfo.tip === 'duzlem' ? 'Düzlem' : yuzey1TipiInfo.tip === 'silindir' ? 'Silindir' : yuzey1TipiInfo.tip === 'kure' ? 'Küre' : yuzey1TipiInfo.tip === 'egri' ? 'Eğri' : 'Bilinmeyen') : 'Tespit ediliyor...' }}
            </a>
        </div>
    </div>

    <!-- BİLGİ:  Seçim 2 Tipi -->
    <div style="display: flex; flex-direction: row; align-items: center; margin-top:5px;">
        <div class="ui label" style="flex: 1;padding: 0.3rem;">
            Seçim 2 Tipi:
            <a class="detail" style="color: black;margin-left: 0.1rem;"> {{ sonuc2Tipi ? sonuc2Tipi : "Seçilen Yok"
                }} </a>
        </div>
        <!-- 🎯 ÖLÇÜM MODU TOGGLE: 5 mod: Kısa Düz, En Kısa, Merkez, En Uzak, Uzak Düz -->
        <!-- NOT: Tüm yüzeylerde (düzlem dahil) aktif - paralel olmayan yüzeylerde de ölçüm modu seçilebilir -->
        <!-- 🎯 SOL TIK: Sonraki mod, SAĞ TIK: Önceki mod -->
        <button *ngIf="secim2MerkezBilgisi || sonuc2Tipi === 'Yüzey'"
                (click)="toggleSecim2OlcumModu()"
                (contextmenu)="toggleSecim2OlcumModuGeri($event)"
                title="Sol tık: Sonraki mod | Sağ tık: Önceki mod"
                style="margin-left: 4px; padding: 2px 6px; font-size: 0.7rem; border: 1px solid #666; border-radius: 3px; cursor: pointer;"
                [ngStyle]="{'background': secim2OlcumModu === 'enKisaDuz' ? '#2196F3' : secim2OlcumModu === 'enKisa' ? '#607D8B' : secim2OlcumModu === 'merkez' ? '#4CAF50' : secim2OlcumModu === 'enUzak' ? '#FF5722' : secim2OlcumModu === 'enUzakDuz' ? '#9C27B0' : '#888', 'color': 'white'}">
            {{ getOlcumModuLabel(secim2OlcumModu) }}
        </button>
    </div>

    <!-- BİLGİ:  Seçim 2 Yüzey Tipi -->
    <div style="display: flex; flex-direction: row;margin-top:3px;" *ngIf="yuzey2TipiInfo && sonuc2Tipi === 'Yüzey'">
        <div class="ui label" style="flex: 1;padding: 0.3rem;background-color: #f3e5f5;">
            Yüzey Tipi:
            <a class="detail" style="color: black;margin-left: 0.1rem;">
                {{ yuzey2TipiInfo?.tip ? (yuzey2TipiInfo.tip === 'duzlem' ? 'Düzlem' : yuzey2TipiInfo.tip === 'silindir' ? 'Silindir' : yuzey2TipiInfo.tip === 'kure' ? 'Küre' : yuzey2TipiInfo.tip === 'egri' ? 'Eğri' : 'Bilinmeyen') : 'Tespit ediliyor...' }}
            </a>
        </div>
    </div>

    <!-- NOT:  Sonuç -->
    <div class="ui horizontal divider header" *ngIf="sonuc?.turu"
        style="margin-top: 0.1rem;margin-bottom:0.1rem;color: white;text-transform: unset;font-size:0.8rem;">
        Sonuç:
    </div>


    <!-- NOT: Ölçüm Sonucu -->
    <div style="display: flex; flex-direction: row;margin-top:5px;" *ngIf="sonuc?.turu=='Mesafe'">
        <div class="ui label" style="flex: 1;padding: 0.3rem;">
            {{ sonuc?.mesafe?.aciklama }} :
            <a class="detail" style="color: black;margin-left: 0.1rem;">
                {{ (sonuc?.mesafe?.birim === '°' ? sonuc?.mesafe?.olcu : birimDonustur(sonuc?.mesafe?.olcu, 'mm', secilenBirim)).toFixed(sonuc?.mesafe?.birim === '°' ? aciBasamak : mesafeBas) }}<sup>{{
                    sonuc?.mesafe?.birim === '°' ? sonuc?.mesafe?.birim : secilenBirim }}</sup>
            </a>
        </div>
    </div>

    <!-- 🎯 PARALEL DEĞİL UYARISI: Yüzeyler paralel değilse uyarı göster -->
    <div style="display: flex; flex-direction: row;margin-top:5px;" *ngIf="sonuc?.mesafe?.paralelDegil === true">
        <div class="ui label" style="flex: 1;padding: 0.4rem;background-color: #fff3cd;border: 1px solid #ffc107;border-radius: 4px;">
            <span style="color: #856404;font-weight: bold;">
                ⚠ Paralel Değil
            </span>
            <span style="color: #856404;font-size: 0.8rem;margin-left: 5px;">
                (Açı: {{ sonuc?.mesafe?.aci?.toFixed(aciBasamak) }}°)
            </span>
            <div style="color: #6c757d;font-size: 0.7rem;margin-top: 3px;">
                Yüzeyler birbirine paralel değil. Ölçüm: Seçim1 {{
                    secim1OlcumModu === 'enKisa' ? 'en kısa' :
                    secim1OlcumModu === 'enKisaDuz' ? 'en kısa dik' :
                    secim1OlcumModu === 'merkez' ? 'merkez' :
                    secim1OlcumModu === 'enUzak' ? 'en uzak' :
                    secim1OlcumModu === 'enUzakDuz' ? 'en uzak dik' : 'en kısa dik'
                }} ↔ Seçim2 {{
                    secim2OlcumModu === 'enKisa' ? 'en kısa' :
                    secim2OlcumModu === 'enKisaDuz' ? 'en kısa dik' :
                    secim2OlcumModu === 'merkez' ? 'merkez' :
                    secim2OlcumModu === 'enUzak' ? 'en uzak' :
                    secim2OlcumModu === 'enUzakDuz' ? 'en uzak dik' : 'en kısa dik'
                }}
            </div>
        </div>
    </div>

    <div style="display: flex; flex-direction: row;margin-top:5px;" *ngIf="sonuc?.turu=='Hata'">
        <div class="ui label" style="flex: 1;padding: 0.3rem;background-color: #ffcccc;">
            ⚠️ {{ sonuc?.mesafe?.aciklama }}
        </div>
    </div>

    <!-- 🎯 ÖLÇÜM KALICI OLSUN BUTONU -->
    <div style="display: flex; flex-direction: row;margin-top:8px;margin-bottom:5px;" *ngIf="kaliciYapilabilirMi">
        <button
            (click)="olcumKaliciYap()"
            style="flex: 1; padding: 0.5rem; background: linear-gradient(135deg, #4CAF50 0%, #2E7D32 100%); color: white; border: none; border-radius: 4px; cursor: pointer; font-weight: bold; font-size: 0.85rem; display: flex; align-items: center; justify-content: center; gap: 6px; box-shadow: 0 2px 4px rgba(0,0,0,0.2);"
            title="Bu ölçümü kalıcı olarak kaydet. Dialog kapatılsa bile ölçüm ürün ağacında görünmeye devam eder.">
            <span>📌</span>
            <span>Ölçüm Kalıcı Olsun</span>
        </button>
    </div>

    <!-- NOT: Ölçüm Geçmişi -->
    <!-- <div class="ui horizontal divider header" *ngIf="olcumGecmisi.length > 0"
        style="margin-top: 0.1rem;margin-bottom:0.1rem;color: white;text-transform: unset;font-size:0.8rem;">
        Ölçüm Geçmişi (Son {{ olcumGecmisi.length }} ölçüm):
    </div>

    <div style="max-height: 200px;overflow-y: auto;margin-top:5px;" *ngIf="olcumGecmisi.length > 0">
        <div style="display: flex; flex-direction: row;padding:3px;border-bottom: 1px solid #ddd;font-size: 0.75rem;" *ngFor="let olcum of olcumGecmisi">
            <div style="flex: 1;">
                <strong>{{ olcum.aciklama }}</strong>:
                {{ (olcum.birim === '°' ? olcum.olcu : birimDonustur(olcum.olcu, olcum.birim, secilenBirim)).toFixed(4) }}<sup>{{ olcum.birim === '°' ? olcum.birim : secilenBirim }}</sup>
            </div>
            <div style="width: 100px;text-align: right;color: #666;font-size: 0.7rem;">
                {{ olcum.tur }}
            </div>
            <div style="width: 80px;text-align: right;color: #999;font-size: 0.7rem;">
                {{ olcum.zaman | date:'HH:mm:ss' }}
            </div>
        </div>
    </div> -->


</div>